export default class ControlDto {
    deviceId: string;//设备id
    ispDeviceId: string;//注册Id
}